<template>
    <a-drawer title="编辑分组" placement="right" width="650" :closable="true" :visible="show" @close="$emit('close', null)">
        <div class="list-content">
            <a-list size="large" :data-source="listData">
                <a-list-item slot="renderItem" slot-scope="item, index" class="list-items">
                    {{ item.name }}
                    <div slot="extra">
                        <a class="link-item" @click="onShowInner('edit', index)">编辑信息</a>
                        <a class="link-item" @click="onShowInner('user', index)">分组客户</a>
                        <a-popconfirm placement="bottomRight" title="确定要删除吗？" @confirm="onDelete(index)">
                            <a>删除分组</a>
                        </a-popconfirm>
                    </div>
                </a-list-item>
            </a-list>
        </div>
        <a class="footer" @click="onShowInner('edit')">+ 添加分组</a>
        <a-drawer :width="this.innerMode === 'user' ? '900' : '500'" :closable="true" :visible="showInner"
            :maskClosable="false" @close="() => showInner = false">
            <a-form-model class="inner-form" ref="modelForm" :model="formModel" layout="horizontal" :labelCol="{ span: 2 }"
                :wrapperCol="{ span: 20 }" v-if="this.innerMode === 'edit'">
                <a-form-model-item label="名称">
                    <a-input v-model="formModel.name" placeholder="请输入名称" />
                </a-form-model-item>
                <a-form-model-item label="价格">
                    <a-input v-model="formModel.money" placeholder="请输入价格" />
                </a-form-model-item>
                <a-form-model-item>
                    <a-button type="primary" @click="submitGroup">提交</a-button>
                </a-form-model-item>
            </a-form-model>
            <div v-if="innerMode === 'user'">
                <a-transfer :list-style="{ width: '350px', height: '750px'}" :data-source="allUser" show-search
                    :filter-option="filterOption" :target-keys="selectedUserId" :render="item => item.title" @change="onTransferChange" />
                <a-button class="transfer-button" type="primary" @click="submitUser">提交</a-button>
            </div>
        </a-drawer>
    </a-drawer>
</template>

<script>
import {
    mapState
} from 'vuex'

export default {
    computed: {
        ...mapState('stored', ['userInfo'])
    },
    data() {
        return {
            selectedId: -1,
            listData: [],
            showInner: false,
            innerMode: '',
            formModel: {},
            allUser: [],
            selectedUserId: []
        }
    },
    created() {

    },
    mounted() {
        this.onInit()
    },
    props: {
        gid: {
            default: -1
        },
        show: {
            default: false
        }
    },
    watch: {
        gid() {
            this.onInit()
        }
    },
    methods: {
        async onInit() {
            let res = await this.$util.request(this.$ctrl.group.get, {
                status: this.userInfo.stationId,
                g_id: this.gid
            })
            this.listData = res.data.data
        },
        async onInitGuest() {
            let res = await this.$util.request(this.$ctrl.guest_source.get, {
                status: this.userInfo.stationId,
                limit: 9999
            })
            this.allUser = res.data.data.map((s) => ({
                key: s.id.toString(),
                title: s.name
            }))
            res = await this.$util.request(this.$ctrl.group.guest_get, {
                status: this.userInfo.stationId,
                ass_id: this.selectedId,
                limit: 9999,
                type: 1
            })
            this.selectedUserId = res.data.data.map((s) => s.id.toString())
        },
        async onShowInner(e, f) {
            if (Number.isFinite(f)) {
                this.selectedId = this.listData[f].id
                this.formModel.name = this.listData[f].name
                this.formModel.money = this.listData[f].money
            } else {
                this.selectedId = -1
                this.formModel.name = undefined
                this.formModel.money = undefined
            }
            this.innerMode = e
            await this.onInitGuest()
            this.showInner = true
        },
        submitGroup() {
            this.$util.request(this.$ctrl.group.edit, {
                status: this.userInfo.stationId,
                id: this.selectedId > 0 ? this.selectedId : undefined,
                g_id: this.gid,
                ...this.formModel
            }).then((res) => {
                if (res.code === 1) {
                    this.$notification.success({
                        message: '提交成功'
                    })
                    this.showInner = false
                    this.onInit()
                } else {
                    this.$notification.error({
                        message: '提交失败'
                    })
                }
            })
        },
        filterOption(inputValue, option) {
            return option.title.includes(inputValue)
        },
        onTransferChange(selectedUserId) {
            this.selectedUserId = selectedUserId
        },
        submitUser() {
            this.$util.request(this.$ctrl.group.guest_edit, {
                // status: this.userInfo.stationId,
                ass_id: this.selectedId > 0 ? this.selectedId : undefined,
                c_id: this.selectedUserId.map((s) => Number(s))
            }).then((res) => {
                if (res.code === 1) {
                    this.$notification.success({
                        message: '提交成功'
                    })
                    this.showInner = false
                    this.onInit()
                } else {
                    this.$notification.error({
                        message: '提交失败'
                    })
                }
            })
        },
        onDelete(e) {
            this.$util.request(this.$ctrl.group.del, {
                id: this.listData[e].id
            }).then((res) => {
                if (res.code === 1) {
                    this.$notification.success({
                        message: '删除成功'
                    })
                    this.onInit()
                } else {
                    this.$notification.error({
                        message: '删除失败'
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
    .list-content {
        height: 750px;
        overflow: scroll;
        border: 1px solid lightgray;

        .list-items {
            padding: 14px 16px;
            position: relative;

            .link-item {
                margin-right: 20px;
            }
        }
    }

    .footer {
        display: block;
        margin: 25px 0px;
    }

    .inner-form {
        margin-top: 40px;

        & button {
            width: 80px;
            margin-left: 40px;
        }
    }

    .transfer-button {
        margin: 20px 0px;
        width: 80px;
    }
</style>
